"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useStyles = (0, makeStyles_1.default)((theme) => ({
    tableActions: {
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
        height: 30,
        width: '100%',
        boxSizing: 'border-box',
        verticalAlign: 'top',
        display: 'flex',
        padding: '0 12px',
        '& svg': {
            cursor: 'pointer',
            width: 20,
            height: 20,
            padding: '2pt',
        },
    },
    buttonGroup: {
        display: 'flex',
        // marginLeft: -5, // offset first icon left padding
    },
    button: {
        boxShadow: '0 0 0',
        minWidth: 30,
    },
    iconButton: {
        padding: '0 5px',
        margin: '0',
    },
    iconButtonIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    iconRotate: {
        transform: 'scaleY(-1)',
    },
    sortable: {
        cursor: 'pointer',
    },
    componentWrapper: {
        position: 'relative',
        minWidth: '100%',
        width: '100%',
        display: 'inline-block',
        fontFamily: theme.typography.fontFamily,
    },
    grid: {
        overflow: 'auto',
        paddingBottom: 5,
        backgroundColor: 'rgb(0, 0, 0, 0.08)',
    },
    header: {
        height: 35,
        boxSizing: 'border-box',
        width: 'fit-content',
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'row',
        minWidth: '100%',
        // alignItems: 'center',
        // we can not use contrast text color because the algorithm does not count in the alpha 40
        //color: theme.palette.getContrastText(`${theme.palette.primary.light}40`),
        color: 'black',
        backgroundColor: `${theme.palette.primary.light}40`,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        padding: '0 16px !important',
    },
    tableRowActions: {
        flexShrink: 0,
        height: 20,
        verticalAlign: 'top',
        display: 'inline-flex',
        padding: 0,
        // overflow: 'hidden',
        '& svg': {
            cursor: 'pointer',
            width: 19,
            height: 19,
            padding: '2pt',
        },
    },
    tableSpeedDial: {
        width: 20,
        height: 20,
        minHeight: 20,
        boxShadow: 'none',
    },
    tableSpeedDialAction: {
        width: 30,
        height: 30,
        minHeight: 30,
    },
    tableSpeedDialTooltip: {
        margin: 0,
        paddingRight: 20,
        backgroundColor: 'transparent',
        zIndex: 1200,
    },
    tableSpeedDialIcon: {
        width: '20px !important',
        height: '20px !important',
    },
    tableSpeedDialButton: {
        backgroundColor: `${theme.palette.primary.main} !important`,
        color: `white !important`,
        '&:hover': {
            backgroundColor: `${theme.palette.primary.light} !important`,
        },
    },
    tableSpeedDialButtonDisabled: {
        opacity: '0.5 !important',
    },
    tableRowHeader: {
        flexShrink: 0,
        display: 'flex',
        lineHeight: '35px',
    },
    tableRowHeaderLabel: {
        display: 'inline-block',
        flex: '1 1 auto',
        overflow: 'hidden',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        margin: 'auto',
    },
    rowDraggable: {
        alignSelf: 'center',
    },
    draggable: {
        zIndex: 999,
    },
    draggableIcon: {
        width: 10,
        cursor: 'col-resize',
    },
    headerCellDraggable: {
        marginLeft: 5,
    },
    tableWrapper: {
        minWidth: '100%',
        display: 'inline-block',
    },
    dataWrapper: {
        minHeight: 60,
        minWidth: '100%',
        width: 'fit-content',
    },
    row: {
        boxSizing: 'border-box',
        borderBottom: '1px solid #cdcdcd',
        minWidth: '100%',
        minHeight: 30,
        '&:hover': {
            backgroundColor: `${theme.palette.highlight} !important`,
        },
        padding: '0px 16px 1px',
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0,
        cursor: 'pointer',
    },
    highlightedRow: {
        backgroundColor: `${theme.palette.highlight} !important`,
    },
    defaultCursor: {
        cursor: 'default',
    },
    radioButton: {
        padding: 0,
        // verticalAlign: 'top',
    },
    tableCell: {
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'inline-block',
        verticalAlign: 'top',
        width: '100%',
        '& input': {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    },
    tableCellFlex: {
        display: 'flex',
    },
    cellWrapper: {
        flexShrink: 0,
        display: 'flex',
        paddingRight: 10,
        boxSizing: 'border-box',
    },
    dialogTitleHeader: {
        fontWeight: 700,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    dialogActions: {
        padding: '10px 24px',
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
    dialogButtonLabel: {
        textTransform: 'capitalize',
    },
}));
//# sourceMappingURL=table-field-styles.js.map